import { loggedUserReducer } from './reducer';

export const loginRootReducer = loggedUserReducer;

export const loginRootReducerStateKey = 'loggedInUser';
